import {Grid, Typography} from '@yandex-delivery/blocks'

import {Body, CitySuggest, PointSelect} from 'src/shared/components/desktop'
import {i18n} from 'src/shared/config'
import {SourcePointDeliveryMethod} from 'src/shared/types'

import {PointsByCityModal} from '../PointsByCityModal/PointsByCityModal'
import {usePointDropOff} from './hooks'
import type {Props} from './types'

// todo PointDropOff должен быть разбит на два компонент, как адрес и контакы в экспрессе
export function PointDropOff(props: Props) {
  const {
    isPending,
    openModalHandler,
    points,
    isModalVisible,
    citySelectHandler,
    closeModalHandler,
    pointSelectHandler,
    preparedPoints,
    selectedPoint,
    selectedCity,
    names,
  } = usePointDropOff({name: props.name})

  return (
    <>
      <Grid xs={12} item>
        <Body
          lead={
            <Typography group="tight" mt="m" thickness="medium" variant="body2">
              {i18n('ndd.point.point-selector.city', 'Город')}
            </Typography>
          }
          tail={<CitySuggest data-testid={`ndd.city_${names.city}`} name={names.city} pointType="a" />}
        />
      </Grid>
      <Grid xs={12} item>
        <Body
          lead={
            <Typography group="tight" mt="m" thickness="medium" variant="body2">
              {i18n('ndd.point.point-selector.dropoff_point', 'Пункт приёма')}
            </Typography>
          }
          tail={
            <PointSelect
              data-testid={`ndd.point_${names.point}`}
              isDisabled={!selectedCity}
              isPending={isPending}
              name={names.point}
              onShow={openModalHandler}
              placeholder={i18n('ndd.point.point-selector.select_dropoff_point', 'Выберите пункт приёма')}
              points={points}
              trailButtonCaption={i18n('ndd.delivery-method.field.pickup-point.reception-point.button', 'Все пункты')}
            />
          }
        />
      </Grid>
      <PointsByCityModal
        isOpen={isModalVisible}
        isPending={isPending}
        onCitySelect={citySelectHandler}
        onClose={closeModalHandler}
        onPointSelect={pointSelectHandler}
        points={preparedPoints}
        pointType={SourcePointDeliveryMethod.DropOffPoint}
        selectedPoint={selectedPoint}
        selectedPointCity={selectedCity?.address}
      />
    </>
  )
}
